export const IconSidebarButton = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 12 12" fill="none">
        <rect x="0.5" y="2" width="11" height="8" rx="1.75" stroke="currentColor"
            style={{ transition: 'all 0.3s ease-in-out', opacity: props.open ? 1 : 0, }}
        />

        <rect
            x={0} y={0.5} width={1} height={9} fill="currentColor"
            style={{
                transformBox: 'fill-box',
                transformOrigin: 'center',
                willChange: 'transform',
                transform: props.open ? 'rotate(0deg) translate(3px, 1px)' : 'rotate(-90deg) translate(-0.75px, 5.5px)',
            }}
        />

        <rect x={1.5} y={1.5} width={9} height={1} fill="currentColor"
            style={{ transition: 'all 0.3s ease-in-out', opacity: props.open ? 0 : 1, }}
         />
        <rect x={1.5} y={9.5} width={9} height={1} fill="currentColor"
            style={{ transition: 'all 0.3s ease-in-out', opacity: props.open ? 0 : 1, }}
         />
    </svg>
)